<template>
  <div v-if="hasSelection" class="pill-wrapper">
    <b-button class="pill">{{ selectedLabel }}</b-button>
  </div>
</template>

<script>
import { find } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'OpeningType',

  props: {
    section: Object,
  },

  computed: {
    ...mapGetters('filter', [
      'sectionFilterSelected',
    ]),

    rawSelectedValue() {
      return this.sectionFilterSelected(this.section.filter)
    },

    hasSelection() {
      const v = this.rawSelectedValue
      if (Array.isArray(v)) return v.length > 0
      return v != null && v !== ''
    },

    selectedLabel() {
      const option = find(this.section.options, ['value', this.rawSelectedValue])
      if (!option) return ''
      return option.label === 'Opening' ? 'Standard Opening' : option.label
    },
  },
}
</script>

<style scoped lang="scss">
.pill-wrapper {
  .pill {
    border-radius: 4px;
    border: 1px solid rgba(28, 36, 51, 0.20);
    background: $color-yellow-lighter;
    width: max-content;
  }
}
</style>
